import React from 'react';
import { Box, Typography } from '@mui/material';

export default function InventoryHistoryEvents({ events = [] }) {
  if (!events.length) return null;
  return (
    <Box sx={{ mt: 1 }}>
      {events.map(event => (
        <Box key={`${event.id}-${event.asset_id}`} sx={{ mb: 1 }}>
          <Typography variant="body2">
            {event.action === 'removed' ? 'Удалён из сделки' : 'Добавлен в сделку'}: {event.asset_name}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {new Date(event.event_date).toLocaleString('ru-RU')}
            {event.user_name ? ` · ${event.user_name}` : ''}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}
